import React, { Component } from "react";
import PropTypes from "prop-types";
import { observer, inject } from "mobx-react";
import { GridColumn } from "arv-reactcomponents";
import { Anchor } from "arv-extends";
import { FOOTER } from "npmlinks-constants";

const {
  SOCIAL_MEDIA_LINKS: { TITLE, LINKS },
} = FOOTER;

@inject("CommonStore")
@observer
class SocialLinks extends Component {
  render() {
    const { isDesktop } = this.props.CommonStore;

    return (
      <GridColumn className="nwc-grid-col-sm-4 nwc-grid-col-xs-6">
        <h3 className="wc-footersociallinks-title">{TITLE}</h3>
        <div className="wc-footersociallinks-list">
          {LINKS.map(LINK => (
            <Anchor.component
              to={LINK.URL}
              href={LINK.URL}
              className="wc-footersociallinks-anchor"
              target={isDesktop ? "_blank" : "_self"}
            >
              <i
                className={`${LINK.ICON} wc-footer-sociallinkicons`}
                title={LINK.TITLE}
              />
            </Anchor.component>
          ))}
        </div>
      </GridColumn>
    );
  }
}

SocialLinks.wrappedComponent.propTypes = {
  CommonStore: PropTypes.shape({
    isDesktop: PropTypes.bool.isRequired,
  }).isRequired,
};

export default SocialLinks;
